module.exports = __webpack_public_path__ + "img/place.ce976d0e.svg";